<template>
  <div class="card editable-card">
      <div style="display: flex;">
        <div class="links-body">
          <div class="statBlock">
            <div class="card-header" v-if="$slots.header">
              <slot name="header"></slot>
            </div>
            <div class="card-body">
              <!-- Create form fields for address input -->
              <div class="inputs address-fields">
                <input v-model="address.address_one" placeholder="Address 1" />
                <input v-model="address.address_two" placeholder="Address 2" />
                <input v-model="address.city" placeholder="City" />
                <input v-model="address.state" placeholder="State/Province" />
                <input v-model="address.zip_code" placeholder="Postal Code" />
                <input v-model="address.phone" placeholder="Primary Phone Nuber" />
              </div>
              <div class="actionbuttons">
                <button @click="save" class="btn btn-info btn-fill btn-wd">Save</button>
              </div>
            </div>
            <div class="card-footer" v-if="$slots.footer">
              <slot name="footer"></slot>
            </div>
          </div>
      </div>
    </div>
  </div>

</template>
<script>
  import Card from './Card.vue'

  export default {
    name: 'address-form-card',
    components: {
      Card
    },
    props: {
      pAddress : {
        type: Object,
        default () {return {}}
      }
    },
    data () {
      return {
        address: {
          address_one: '',
          address_two: '',
          city: '',
          state: '',
          zip: '',
          phone: ''
        }
      }
    },
    methods: {
      save () {
        // user saving the information
        let e = {address: this.address}
        this.$emit('address-form-card-update', e)
      }
    },
    mounted () {
      this.address = this.pAddress||{}
    }
  }
</script>
<style>
.editable-card {
  height: calc(100% - 30px);
}

/*.edit-button {
    display: block !important;
    width: calc(100% - 10px);
    text-align: center;
    border-top: 1px solid #dfdfdf;
    font-size: 0.8em;
    margin-bottom: 5px;
    margin-left: 5px;
    margin-top: 30px;
}*/

.links-body {
    width: 100% !important;
}

.address-fields input {
  border: 1px solid#dfdfdf;
  width: calc(50% - 5px);
  margin-bottom: 10px;
  padding: 4px;
}

.address-fields input:nth-child(odd) {
  margin-right: 10px;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
   color: #bfbfbf;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color: #bfbfbf;
}

::-ms-input-placeholder { /* Microsoft Edge */
   color: #bfbfbf;
}

</style>

